import classNames from "classnames";
import {
	PropsWithChildren,
	ReactElement,
	useContext
} from "react";
import {
	ControlAttachmentContext,
	ControlAttachmentOptions,
	getAttachmentClassNames,
	NO_CONTROL_ATTACHMENTS
} from "../ControlAttachment";
import { FontIconName } from "../Icon/Icon";
import styles from "./DropOverInput.module.less";
import { IconButton } from "../IconButton/IconButton";

export type DropOverInputAction = {
	icon: FontIconName;
	onClick(): void;
};

export type DropOverInputProps = {
	isActive: boolean;
	isInvalid?: boolean;
	isDisabled?: boolean;
	attachedOn?: ControlAttachmentOptions;
	actions: readonly DropOverInputAction[];
};

export const DropOverInput = (props: PropsWithChildren<DropOverInputProps>): ReactElement => {
	const {
		isActive,
		isInvalid = false,
		isDisabled = false,
		attachedOn = [],
		actions,
		children
	} = props;

	const {
		attachedOn: attachedOnFromContext
	} = useContext(ControlAttachmentContext);

	return (
		<div
			className={classNames(
				styles.root,
				{
					[styles.root_isActive]: isActive,
					[styles.root_isInvalid]: isInvalid,
					[styles.root_isDisabled]: isDisabled
				},
				getAttachmentClassNames(attachedOn, attachedOnFromContext)
			)}
		>
			<div
				className={styles.inputWrapper}
			>
				<ControlAttachmentContext.Provider value={NO_CONTROL_ATTACHMENTS}>
					{ children }
				</ControlAttachmentContext.Provider>
			</div>
			<ul className={styles.suffix}>
				{actions.map((x, i) => (
					<li
						key={i}
						className={styles.action}
					>
						<IconButton
							trackingId="dropover-input-icon"
							icon={x.icon}
							kind="transparent"
							onClick={x.onClick}
							hasNoBorderRadius
							isDisabled={isDisabled}
							height="fill"
							width="fill"
							tabIndex={-1}
							bubbleClick={false}
						/>
					</li>
				))}
			</ul>
		</div>
	);
};
DropOverInput.displayName = "DropOverInput";
